import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import copy from 'copy-to-clipboard';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal, showModalTop } from '../../../actions';
import { showConfirmationModal } from '../../../actions/App';
import {
  getCollection,
  showCollectionAddModal,
  removeFilesFromCollection,
  setSidebarCollection,
  addFilesToSidebarCollectionFilesList,
  removeFilesFromSidebarCollectionFilesList,
} from '../../../actions/Collections';
import {
  setSelectedFile,
  showUploadModal,
  setUploadModalMode,
  deleteFile,
  removeFilesFromFilesList,
  updateFilesOnFilesList,
  updateFile,
} from '../../../actions/Files';

import {
  APIaddFilesToCollection,
  APIsetCollectionFeaturedImage,
} from '../../../api/Collections';
import {
  APIcreateFilesGroup,
  APIgetFilePublicUrl,
  APIchangeFileThumbnail,
  APIremoveFileThumbnail,
  APIrefreshFileThumbnail,
} from '../../../api/Files';
import { APIgetShareFilePublicUrl } from '../../../api/Shares';

import FileActionsIntegrations from '../ActionsIntegrations';
import FileExpirationIcon from '../ExpirationIcon';
import UpgradePlanButton from '../../UpgradePlanButton';

import { isArchive } from '../../../helpers/App';
import {
  userCan,
  userHasCap,
} from '../../../helpers/Auth';
import { userHasFeature } from '../../../helpers/Features';
import { printFile } from '../../../helpers/Files';
import { addFlashMessage } from '../../../helpers/FlashMessages';
import { getSetting } from '../../../helpers/Settings';
import { upgradeModalIfNeeded } from '../../../helpers/UpgradePlan';

class FileHeaderActions extends PureComponent {
  constructor(props) {
    super(props);

    this.handleRemoveFromCollection = this.handleRemoveFromCollection.bind(this);
  }

  isFileInSidebarCollection(fileUuid) {
    const { sidebarCollectionFiles } = this.props;
    return sidebarCollectionFiles.find(scf => (scf.uuid === fileUuid));
  }

  handleCopyFilePublicUrl(file) {
    const { intl } = this.props;

    APIgetFilePublicUrl(file.uuid, {
      cf: (getSetting('allow_public_urls') || userHasCap('public_file_urls')) ? true : undefined,
    })
      .then((response) => {
        const { data } = response;
        if (data && data.url) {
          copy(data.url);
          addFlashMessage({
            type: 'success',
            text: intl.formatMessage({ defaultMessage: 'File public URL has been copied' }),
          });
        }
      });
  }

  handleRemoveFromCollection(file) {
    const {
      intl,
      openConfirmationModal,
      collection,
      deleteFilesFromCollection,
    } = this.props;

    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: 'Do you want to remove this file from {collectionName} Collection?',
      }, { collectionName: collection.name }),
      processingText: intl.formatMessage({ defaultMessage: 'Removing' }),
      onConfirm: () => (
        deleteFilesFromCollection(collection.uuid, {
          files: [file.uuid],
        })
      ),
    };
    openConfirmationModal(file, modalParams);
  }

  handleDeleteFile(file) {
    const {
      intl,
      openConfirmationModal,
      removeFile,
    } = this.props;

    const mtext = (file.versions && file.versions.length > 0) ?
      intl.formatMessage({ defaultMessage: 'Are you sure you want to delete all versions of this file?' }) :
      intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this file?' });

    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: `{mtext} Files can be restored from the trash.`,
      }, { mtext }),
      confirmText: intl.formatMessage({ defaultMessage: 'Delete' }),
      onConfirm: () => (
        removeFile(file.uuid)
      ),
    };
    openConfirmationModal(file, modalParams);
  }

  render() {
    const {
      intl,
      history,
      file,
      collection,
      sidebarCollection,
      handleAddToSidebarCollection,
      handleRemoveFromSidebarCollection,
      handleMoveToCollection,
      handleEditFile,
      handleDownloadRequestFile,
      handleRequestDownloadFile,
      handleChangeOwner,
      handleArchive,
      handleSetCollectionFeaturedImage,
      handleChangeThumbnail,
      handleRefreshThumbnail,
      handleRemoveThumbnail,
      openChangeThumbnailModal,
      shareUuid,
      share,
      inModal,
    } = this.props;
    const suffix = inModal ? '-m' : '';

    return (
      <>
        {!shareUuid && !inModal && (
          <FileExpirationIcon file={file} />
        )}
        <UncontrolledDropdown>
          <DropdownToggle nav className="options btn btn-link" aria-label={intl.formatMessage({ defaultMessage: 'More actions' })}>
            <i className="far fa-ellipsis-h" />
          </DropdownToggle>
          <DropdownMenu right container=".file-modal">
            {(
              file.type !== 'link' &&
              inModal &&
              file.urls.print && (
                (share && share.allow_download) ||
                (!share && userCan('file.download', file))
              )
            ) && (
              <DropdownItem
                onClick={(e) => {
                  e.preventDefault();
                  printFile(file.urls.print);
                }}
              >
                <i className="far fa-print" />
                {intl.formatMessage({ defaultMessage: 'Print' })}
              </DropdownItem>
            )}

            {(!shareUuid && !userCan('file.download', file) && userCan('file.request_download', file) && !file.request) && (
              <DropdownItem
                onClick={(e) => {
                  e.preventDefault();
                  handleRequestDownloadFile(file);
                }}
              >
                <i className="far fa-cart-arrow-down" />
                {intl.formatMessage({ defaultMessage: 'Request Download' })}
              </DropdownItem>
            )}

            {(!shareUuid && (!file.archived || getSetting('cs1'))) && (
              <>
                {(sidebarCollection && !file.archived && sidebarCollection.open) && (
                  this.isFileInSidebarCollection(file.uuid) ? (
                    <DropdownItem
                      href="#remove-from-sidebar-collection"
                      id={`FileActionCollectionSidebar-${file.uuid}${suffix}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleRemoveFromSidebarCollection(sidebarCollection.uuid, file.uuid);
                      }}
                    >
                      <i className="far fa-folder-minus" />
                      {intl.formatMessage({
                        defaultMessage: 'Remove from {sidebarCollectionName}',
                      }, { sidebarCollectionName: sidebarCollection.name })}
                    </DropdownItem>
                  ) : (
                    <DropdownItem
                      onClick={(e) => {
                        e.preventDefault();
                        handleAddToSidebarCollection(sidebarCollection.uuid, file);
                      }}
                    >
                      <i className="far fa-folder-plus" />
                      {intl.formatMessage({
                        defaultMessage: 'Add to {sidebarCollectionName}',
                      }, { sidebarCollectionName: sidebarCollection.name })}
                    </DropdownItem>
                  ))}
              </>
            )}

            {(
              share &&
              share.allow_download &&
              getSetting('cs1') &&
              userHasFeature('public-file-urls')
            ) && (
              <DropdownItem
                href="#copy-public-url"
                id={`FileActionCopyPublicUrl-${file.uuid}${suffix}`}
                onClick={(e) => {
                  e.preventDefault();
                  APIgetShareFilePublicUrl(shareUuid, file.uuid).then((response) => {
                    const { data } = response;
                    if (data && data.url) {
                      copy(data.url);
                      addFlashMessage({
                        type: 'success',
                        text: intl.formatMessage({ defaultMessage: 'File public URL has been copied' }),
                      });
                    }
                  });
                }}
              >
                <i className="far fa-copy" />
                {intl.formatMessage({ defaultMessage: 'Copy public URL' })}
                <UpgradePlanButton
                  feature="public-file-urls"
                  simple={true}
                />
              </DropdownItem>
            )}

            {(!shareUuid && !userCan('file.download', file) && userCan('file.request_download', file) && file.request) && (
              <DropdownItem
                onClick={(e) => {
                  e.preventDefault();
                  handleDownloadRequestFile(file);
                }}
              >
                <i className="far fa-download" />
                {intl.formatMessage({ defaultMessage: 'Download' })}
              </DropdownItem>
            )}

            {!shareUuid && (
              <>
                {file.type === 'link' && (
                  <DropdownItem
                    onClick={() => {
                      history.push({
                        pathname: `/files/${file.uuid}`,
                        state: {
                          modal: true,
                        },
                      });
                    }}
                  >
                    <i className="fas fa-link-horizontal" />
                    {intl.formatMessage({ defaultMessage: 'View details' })}
                  </DropdownItem>
                )}
                {userCan('file.edit', file) && (
                  <DropdownItem
                    onClick={() => {
                      handleEditFile(file);
                    }}
                  >
                    <i className="fas fa-pencil" />
                    {intl.formatMessage({ defaultMessage: 'Edit' })}
                  </DropdownItem>
                )}
                {userCan('file.delete', file) && (
                  <DropdownItem
                    onClick={() => {
                      this.handleDeleteFile(file);
                    }}
                  >
                    <i className="fas fa-trash" />
                    {intl.formatMessage({ defaultMessage: 'Delete' })}
                  </DropdownItem>
                )}
                {(collection && userCan('collection.remove', collection) && (!isArchive() || getSetting('cs1'))) && (
                  <>
                    {(collection.open && !collection.smart) && (
                      <DropdownItem
                        onClick={() => {
                          this.handleRemoveFromCollection(file);
                        }}
                      >
                        <i className="fas fa-layer-minus" />
                        {intl.formatMessage({ defaultMessage: 'Remove from this Collection' })}
                      </DropdownItem>
                    )}
                    {(collection.open && userCan('add_files_to_collections')) && (
                      <DropdownItem
                        onClick={() => {
                          handleMoveToCollection(file);
                        }}
                      >
                        <i className="fas fa-arrow-alt-right" />
                        {intl.formatMessage({ defaultMessage: 'Move to Collection' })}
                      </DropdownItem>
                    )}
                  </>
                )}
                {userCan('file.change_owner', file) && (
                  <DropdownItem
                    onClick={() => {
                      handleChangeOwner(file.uuid);
                    }}
                  >
                    <i className="fas fa-user-circle" />
                    {intl.formatMessage({ defaultMessage: 'Change Owner' })}
                  </DropdownItem>
                )}
                {userCan('file.edit', file) && (
                  <>
                    {(file.type_group !== 'image') && (
                      <DropdownItem
                        onClick={() => {
                          openChangeThumbnailModal({
                            className: 'modal-select-file modal-select-file-enhanced',
                            handleSelectFile: (thumbnail) => {
                              handleChangeThumbnail(file, thumbnail);
                            },
                            showRemoveButton: true,
                            removeButtonText: intl.formatMessage({ defaultMessage: 'Remove thumbnail' }),
                            handleRemove: () => handleRemoveThumbnail(file),
                          });
                        }}
                        disabled={!userHasFeature('custom-file-thumbnail')}
                      >
                        <i className="fas fa-image" />
                        {intl.formatMessage({ defaultMessage: 'Change thumbnail' })}
                        <UpgradePlanButton
                          feature="custom-file-thumbnail"
                          simple={true}
                        />
                      </DropdownItem>
                    )}
                  </>
                )}
                {(file.type !== 'link' && collection && userCan('collection.edit', collection)) && (
                  <DropdownItem
                    onClick={() => {
                      handleSetCollectionFeaturedImage(collection.uuid, file.uuid);
                    }}
                    disabled={
                      collection.featured_file &&
                      collection.featured_file.uuid === file.uuid
                    }
                  >
                    <i className="fas fa-folder-image" />
                    {intl.formatMessage({ defaultMessage: 'Set as Collection thumbnail' })}
                  </DropdownItem>
                )}
                {file.can_have_thumbnail && (
                  <DropdownItem
                    onClick={() => {
                      handleRefreshThumbnail(file);
                    }}
                  >
                    <i className="fas fa-rotate-right" />
                    {intl.formatMessage({ defaultMessage: 'Refresh thumbnail' })}
                  </DropdownItem>
                )}
                <CopyToClipboard
                  text={file.uuid}
                  options={{
                    format: 'text/plain',
                  }}
                >
                  <DropdownItem
                    onClick={() => {
                      addFlashMessage({
                        type: 'success',
                        text: intl.formatMessage({ defaultMessage: 'File ID has been copied' }),
                      });
                    }}
                  >
                    <i className="fas fa-copy" />
                    {intl.formatMessage({ defaultMessage: 'Copy ID' })}
                  </DropdownItem>
                </CopyToClipboard>
                {((
                  getSetting('cs1') ||
                  getSetting('allow_public_urls') ||
                  (userHasCap('public_file_urls') && (
                    getSetting('public_file_urls') ||
                    !userHasFeature('public_file_urls')
                  ))
                ) && userCan('file.download', file)) && (
                  <DropdownItem
                    className={classnames({ 'inactive silent-pointer-events': !userHasFeature('public-file-urls') })}
                    onClick={(e) => upgradeModalIfNeeded('public-file-urls', () => this.handleCopyFilePublicUrl(file), e)}
                  >
                    <i className="fas fa-copy" />
                    {intl.formatMessage({ defaultMessage: 'Copy public URL' })}
                    <UpgradePlanButton
                      feature="public-file-urls"
                      simple={true}
                    />
                  </DropdownItem>
                )}
                <FileActionsIntegrations files={[file]} />
                {userCan('file.archive') && (
                  <>
                    <DropdownItem divider />
                    {file.archived ? (
                      <DropdownItem
                        className={classnames({ 'inactive silent-pointer-events': !userHasFeature('archive') })}
                        onClick={(e) => upgradeModalIfNeeded('archive', () => handleArchive(file), e)}
                      >
                        <i className="fas fa-box-open" />
                        {intl.formatMessage({ defaultMessage: 'Unarchive' })}
                        <UpgradePlanButton
                          feature="archive"
                          simple={true}
                        />
                      </DropdownItem>
                    ) : (
                      <DropdownItem
                        className={classnames({ 'inactive silent-pointer-events': !userHasFeature('archive') })}
                        onClick={(e) => upgradeModalIfNeeded('archive', () => handleArchive(file), e)}
                      >
                        <i className="fas fa-archive" />
                        {intl.formatMessage({ defaultMessage: 'Archive' })}
                        <UpgradePlanButton
                          feature="archive"
                          simple={true}
                        />
                      </DropdownItem>
                    )}
                  </>
                )}
              </>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      </>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  selectedFiles: state.Files.selectedFiles,
  collection: state.Collections.collection,
  sidebarCollection: state.Collections.sidebarCollection,
  sidebarCollectionFiles: state.Collections.sidebarCollectionFiles,
  sidebarCollectionOpen: state.Collections.sidebarCollectionOpen,
});

const mapDispatchToProps = (dispatch, props) => ({
  handleAddToCollection: (file) => {
    dispatch(setSelectedFile(file));
    dispatch(showCollectionAddModal());
  },
  handleAddToSidebarCollection: (collectionUuid, file) => {
    const { intl } = props;
    APIaddFilesToCollection(collectionUuid, { files: [file.uuid] }).then((response) => {
      dispatch(setSidebarCollection(response.data, false));
    });
    dispatch(addFilesToSidebarCollectionFilesList([file]));
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({ defaultMessage: 'File has been added to Collection' }),
    });
  },
  handleRemoveFromSidebarCollection: (collectionUuid, file) => {
    const { intl } = props;
    dispatch(removeFilesFromCollection(collectionUuid, { files: [file] }));
    dispatch(removeFilesFromSidebarCollectionFilesList([{ uuid: file }]));
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({ defaultMessage: 'File has been removed from Collection' }),
    });
  },
  handleMoveToCollection: (file) => {
    dispatch(setSelectedFile(file));
    dispatch(showCollectionAddModal(true));
  },
  openConfirmationModal: (file, params) => {
    dispatch(setSelectedFile(file));
    dispatch(showConfirmationModal(params));
  },
  deleteFilesFromCollection: (collectionUuid, params) => (
    APIcreateFilesGroup({
      type: 'collection_remove_files',
      data: { collection_uuid: collectionUuid },
    }).then((response) => {
      const fileGroupUuid = response.data.uuid;
      return dispatch(removeFilesFromCollection(collectionUuid, {
        ...params,
        files: params.selectedAllFiles ? [] : params.files,
        fileGroupUuid,
      })).then(() => {
        const { intl } = props;
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'Files have been removed from Collection' }),
        });
        dispatch(removeFilesFromFilesList(params.files.map(f => ({ uuid: f }))));
      });
    })
  ),
  removeFile: fileUuid => (
    dispatch(deleteFile(fileUuid)).then(() => {
      const { intl } = props;
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({ defaultMessage: 'File has been deleted' }),
      });
    })
  ),
  handleEditFile: (file) => {
    dispatch(setSelectedFile(file));
    if (file.type === 'link') {
      dispatch(setUploadModalMode('link'));
    } else {
      dispatch(setUploadModalMode('edit'));
    }
    dispatch(showUploadModal());
  },
  handleDownloadFile: (file, versionId) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files: [file],
      versions: versionId ? [{
        uuid: file.uuid,
        version_id: versionId,
      }] : [],
      backdrop: true,
    }));
  },
  handleDownloadShareFile: (share, file) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files: [file],
      shareUuid: share.uuid,
      requireName: share.require_name,
      requireEmail: share.require_email,
      backdrop: true,
    }));
  },
  handleRequestDownloadFile: (file) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files: [file],
      backdrop: true,
      request: true,
    }));
  },
  handleDownloadRequestFile: (file) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files: [file],
      requestUuid: file.request.uuid,
      availableFileSizes: file.request.file_sizes.map(fs => (`${fs.id}`)),
      backdrop: true,
    }));
  },
  handleShareFile: (file) => {
    dispatch(showModal('ShareModal', {
      className: 'modal-share modal-share-file',
      files: [file],
    }));
  },
  handleChangeOwner: (file) => {
    dispatch(showModal('ChangeOwnerModal', {
      className: 'modal-change-owner',
      files: [file],
    }));
  },
  handleChangeAccess: (file) => {
    dispatch(showModal('AccessModal', {
      className: 'modal-access modal-file-access',
      files: [file],
    }));
  },
  handleArchive: (file) => {
    dispatch(showModal('ArchiveModal', {
      className: 'modal-archive modal-file-archive',
      files: [file],
      action: file.archived ? 'unarchive' : 'archive',
    }));
  },
  handleSetCollectionFeaturedImage: (collectionUuid, fileUuid) => {
    APIsetCollectionFeaturedImage(collectionUuid, fileUuid).then((response) => {
      const { intl } = props;
      if (response.data) {
        dispatch(getCollection(response.data));
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'File has been set as Collection thumbnail' }),
        });
      } else {
        addFlashMessage({
          type: 'danger',
          text: intl.formatMessage({ defaultMessage: 'Something went wrong' }),
        });
      }
    });
  },
  handleChangeThumbnail: (file, thumbnailUuid) => {
    APIchangeFileThumbnail(file.uuid, thumbnailUuid).then((response) => {
      if (response.data) {
        dispatch(updateFilesOnFilesList([
          {
            ...file,
            attributes: response.data.attributes,
            urls: response.data.urls,
          },
        ]));
        addFlashMessage({
          type: 'success',
          text: 'File thumbnail changed',
        });
      } else {
        addFlashMessage({
          type: 'danger',
          text: 'Something went wrong',
        });
      }
    });
  },
  handleRefreshThumbnail: (file) => {
    APIrefreshFileThumbnail(file.uuid).then((response) => {
      const { intl } = props;
      if (response.data) {
        dispatch(updateFilesOnFilesList([
          {
            ...file,
            attributes: response.data.attributes,
            urls: response.data.urls,
            can_have_thumbnail: response.data.can_have_thumbnail,
          },
        ]));
        addFlashMessage({
          type: 'success',
          text: 'File thumbnail refreshed',
        });
      } else {
        addFlashMessage({
          type: 'danger',
          text: intl.formatMessage({ defaultMessage: 'Something went wrong' }),
        });
      }
    });
  },
  handleRemoveThumbnail: (file) => (
    APIremoveFileThumbnail(file.uuid).then((response) => {
      if (response.data) {
        dispatch(updateFilesOnFilesList([
          {
            ...file,
            attributes: response.data.attributes,
            urls: response.data.urls,
            can_have_thumbnail: response.data.can_have_thumbnail,
          },
        ]));
        addFlashMessage({
          type: 'success',
          text: 'File thumbnail removed',
        });
      } else {
        const { intl } = props;
        addFlashMessage({
          type: 'danger',
          text: intl.formatMessage({ defaultMessage: 'Something went wrong' }),
        });
      }
    })
  ),
  updateFileAction: file => (
    dispatch(updateFile(file))
  ),
  openChangeThumbnailModal: (params) => {
    dispatch(showModalTop('FileSelectModalEnhanced', params));
  },
});

FileHeaderActions.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  file: PropTypes.object.isRequired,
  handleAddToSidebarCollection: PropTypes.func.isRequired,
  handleRemoveFromSidebarCollection: PropTypes.func.isRequired,
  handleMoveToCollection: PropTypes.func.isRequired,
  openConfirmationModal: PropTypes.func.isRequired,
  deleteFilesFromCollection: PropTypes.func.isRequired,
  handleEditFile: PropTypes.func.isRequired,
  handleRequestDownloadFile: PropTypes.func.isRequired,
  handleDownloadRequestFile: PropTypes.func.isRequired,
  handleChangeOwner: PropTypes.func.isRequired,
  handleArchive: PropTypes.func.isRequired,
  handleSetCollectionFeaturedImage: PropTypes.func.isRequired,
  handleChangeThumbnail: PropTypes.func.isRequired,
  handleRefreshThumbnail: PropTypes.func.isRequired,
  handleRemoveThumbnail: PropTypes.func.isRequired,
  removeFile: PropTypes.func.isRequired,
  openChangeThumbnailModal: PropTypes.func.isRequired,
  collection: PropTypes.object,
  sidebarCollection: PropTypes.object,
  sidebarCollectionFiles: PropTypes.array,
  shareUuid: PropTypes.string,
  share: PropTypes.object,
  inModal: PropTypes.bool,
};

FileHeaderActions.defaultProps = {
  collection: null,
  sidebarCollection: null,
  sidebarCollectionFiles: [],
  shareUuid: null,
  share: null,
  inModal: false,
};

export default injectIntl(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FileHeaderActions),
));
